import React, { Component } from "react";
import DisplayCards from "./displaycards";
import DisplaySimpleCards from "./displaySimpleCards";
import TabHeader from "../../forms/tabHeader";
import PieDiagram from "./piechart";
import { ALL, earningsBackground, earningsButton } from "../../../store/types";
import { Paper } from "@material-ui/core";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import moment from "moment";
import { FormatCurrency } from "../currencyFormatter";
import {
  getDashboardData,
  getAumData,
  getInvestors,
  getFrequentMailBackRequest,
  getInvestorDetails,
  getDashboardDataAum,
  getSipSummary,
  PosterOpen,
} from "../../../store/actions";
import { getMailbackList } from "../../../store/actions/mailback";
import { getProfileData } from "../../../store/actions/profile";
import { connect } from "react-redux";
import {
  AUTHORIZATION_PENDING,
  AUTHORIZATION_APPROVED,
  AUTHORIZATION_EXPIRED,
  INACTIVE_INVESTORS,
  ACTIVE_INVESTORS,
  NEW_INVESTORS,
  EXPIRING_NEXT_MONTH,
  CLOSED_THIS_MONTH,
  SIP_INVESTMENTS,
} from "../../../store/types";
import Image from "../../Image";
import { DashboardPosterDialog } from "../customModal";

const windowWidth = window.outerWidth;
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date().toLocaleDateString(),
      reports: [],
      report: { value: "" },
      Tab: "AUM_SUMMARY",
      PosterOpen: true,
    };
  }

  goToRoute = (path) => () => {
    this.props.history.push({
      pathname: "/dashboard/transaction-summary",
      state: {
        active: path,
      },
    });
  };

  goToSIPRoute = (path) => () => {
    this.props.history.push({
      pathname: "/dashboard/SipSummaryTypes",
      state: {
        active: path,
      },
    });
  };

  async componentDidMount() {
    this.props.getProfileData({
      Agent: this.props.token,
      UserId: this.props.userId,
      customfund: "189",
    });

    const body = {
      AgentCode: this.props.token,
      customfund: "189",
      UserId: this.props.userId,
      DateVal: moment(new Date()).format("MM-DD-YYYY"),
    };
    this.props.getDashboardDataAum(body);

    this.props.getDashboardData({
      AgentCode: this.props.token,
      customfund: "189",
    });

    this.props.getInvestors({
      ARN: this.props.token,
      customfund: "189",
      AllFavFlag: "A",
    });

    const MailParams = {
      customfund: "189",
    };

    const response = await this.props.getMailbackList(MailParams);
    if (response) {
      this.setState({
        reports: response.DtData,
      });
    }
    // const sipParams = {
    //   Uid: this.props.userId,
    //   customfund: "189",
    //   AgentCode: this.props.token,
    //   DateVal: moment(new Date()).format("MM-DD-YYYY"),
    // };
    // const Rresponse =  this.props.getSipSummary(sipParams);
  }
  handleChangeSubReports = (value) => () => {
    this.props.history.push({
      pathname: `/mailBackRequest`,
      state: {
        value: value,
      },
    });

    window.scrollTo(0, 0);
  };

  currencyConverter = (value) => {
    if (Math.abs(Number(value)) >= 1.0e5) {
      return `${parseInt(Math.abs(Number(value)) / 1.0e5)} Lakhs`;
    } else if (Math.abs(Number(value)) >= 1.0e7) {
      return `${parseInt(Math.abs(Number(value)) / 1.0e7)} Cr`;
    } else if (Math.abs(Number(value)) >= 1.0e3) {
      return `${parseInt(Math.abs(Number(value)) / 1.0e3)} K`;
    } else {
      return Math.abs(Number(value));
    }
  };

  handleChangeTab = (label) => () => {
    this.setState({
      Tab: label,
    });
  };
  closePoster = async () => {
    this.setState({
      PosterOpen: false,
    });
    await this.props.PosterOpen(1);
  };

  //transaction-summary // kebab case // route names , css class names
  //transactionSummary // camel case // variables, function names.
  //transaction_summary  // snake case //
  //TransactionSummary // PascalCase //Class names

  render() {
    const {
      transactionSummary,
      my_aum,
      numberofschemes,
      profileData,
      dashboardAUMData,
      sipSummaryData,
    } = this.props;
    const AmcAumList =
      !!dashboardAUMData && dashboardAUMData.Table4
        ? dashboardAUMData.Table2
        : [];

    const SipAumList =
      !!sipSummaryData && !!sipSummaryData.DtData ? sipSummaryData.DtData : [];
    const sortPieFundChart =
      !!dashboardAUMData && !!dashboardAUMData.Table2
        ? dashboardAUMData.Table2.sort(
            (a, b) => parseFloat(b.aum_percent) - parseFloat(a.aum_percent)
          )
        : [];

    const fundPieData =
      !!sortPieFundChart && !!sortPieFundChart.length
        ? sortPieFundChart.slice(0, 3).map((ele) => ({
            name: ele.descr,
            value: ele.aum_percent,
            ruppess: ele.aum,
          }))
        : [];

    const AUMDetails =
      !!dashboardAUMData && dashboardAUMData.Table3
        ? dashboardAUMData.Table3
        : [];
    const AUMPieData =
      !!dashboardAUMData && dashboardAUMData.DtData
        ? dashboardAUMData.DtData.map((ele) => ({
            name: ele.category,
            value: ele.aum_percent,
            ruppess: ele.aum,
          }))
        : [];

    return (
      <div className="mainDashboard">
        {this.props.posterStatus === 0 && (
          <DashboardPosterDialog
            open={this.state.PosterOpen}
            close={this.closePoster}
          />
        )}
        {/* <Paper className="dashboard-title">
          <div className="dashboard-title-company">
            {profileData.Distributor_Name} Portfolio
          </div>
          <div className="dashboard-earnings">
            {!!this.props.tran_enable_flag &&
              this.props.tran_enable_flag === "N" && (
                <div className="earnings-position">
                  <Image
                    src={ earningsButton}
                    style={{ height: 50, cursor: "pointer" }}
                    alt="earnings"
                    onClick={() =>
                      this.props.history.push(
                        `/my-earnings`
                      )
                    }
                  />
                </div>
              )}
            <div className="earnings-forground">
              <Image
                src={ earningsBackground}
                className="earinings-background"
                alt="earnings background"
              />
            </div>
          </div>
        </Paper> */}

        <div className="dashboard-my-aum">
          MY AUM
          <span className="dashboard-my-aum-span-1">
            As on :{" "}
            <span className="dashboard-my-aum-span-2">
              {moment(new Date(), "DD/MM/YYYY").format("DD-MM-YYYY")}
            </span>
          </span>
        </div>

        <div className="piecharts-dashboard">
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div className="display-small-front-cards">
              <DisplayCards
                image={"/images/aum_dashboard.svg"}
                name="AUM (₹)"
                values={
                  !!AUMDetails && !!AUMDetails[0] && !!AUMDetails[0].my_aum
                    ? Math.round(AUMDetails[0].my_aum)
                    : "0"
                }
              />
              <DisplayCards
                image={"/images/schemes_dashboard.svg"}
                name="Schemes"
                margin={true}
                values={
                  !!AUMDetails &&
                  !!AUMDetails[0] &&
                  !!AUMDetails[0].Numberofschemes
                    ? AUMDetails[0].Numberofschemes
                    : "0"
                }
              />
              <DisplayCards
                image={"/images/investors_dashboard.svg"}
                name="Investors"
                values={!!this.props.count ? this.props.count : "0"}
              />
            </div>
          </div>
          <div style={{ flexGrow: 1, flexBasis: 0, display: "flex" }}>
            {/* <div className="dashboard-my-aum">Asset class wise Breakup</div> */}
            {!!AUMPieData && AUMPieData.length > 0 ? (
              <Paper className="pie-chart-paper aum">
                <PieDiagram
                  name="AUM"
                  dataDiffer="AUM"
                  aumpieData={true}
                  symbol="%"
                  className="jing"
                  data={AUMPieData}
                  innerRadius={30}
                  outerRadius={75}
                  height={190}
                  width={
                    !!windowWidth && parseFloat(windowWidth) < 540 ? 300 : 180
                  }
                  cy={85}
                  cx={
                    !!windowWidth && parseFloat(windowWidth) < 540
                      ? 150 - 7.5
                      : 90
                  }
                />
              </Paper>
            ) : !!AUMPieData && AUMPieData.length === 0 ? (
              <Paper className="pie-chart-paper fund" style={{ height: 150 }}>
                <div
                  style={{
                    display: "flex",
                    height: 150,
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    color: "red",
                  }}
                >
                  No Asset Class wise break up Found
                </div>
              </Paper>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="dashboard-my-aum flex-date">
          TRANSACTION SUMMARY
          <span className="dashboard-my-aum-span-1 flex-date-span-1">
            As on :{" "}
            <span className="dashboard-my-aum-span-2">
              {moment(new Date(), "DD/MM/YYYY").format("DD-MM-YYYY")}
            </span>
          </span>
        </div>
        <div className="sales-container">
          <div className="simple-card-container">
            <div className="simple-card-div">
              <DisplaySimpleCards
                image={"/images/transaction_expired.svg"}
                name="Authorization Expired"
                count={transactionSummary.ExpiredTransactions}
                className="simple-card"
                onClick={this.goToRoute(AUTHORIZATION_EXPIRED)}
              />

              <DisplaySimpleCards
                image={"/images/transaction_approved.svg"}
                name="Authorization Approved"
                count={transactionSummary.AuthorisedTransaction}
                className="simple-card"
                onClick={this.goToRoute(AUTHORIZATION_APPROVED)}
              />
              <DisplaySimpleCards
                image={"/images/transaction_pending.svg"}
                name="Authorization Pending"
                count={transactionSummary.AuthorisationPending}
                className="simple-card"
                onClick={this.goToRoute(AUTHORIZATION_PENDING)}
              />

              {/* <DisplaySimpleCards
                image={"/images/transaction_phygital.svg"}
                name="Phygital Transactions"
                count={transactionSummary.PhysicalTransactions}
                className="simple-card"
                // onClick={this.goToRoute(PHYSICAL_TRANSACTIONS)}
              /> */}
              <DisplaySimpleCards
                image={"/images/transaction_sips.svg"}
                name="SIP's"
                count={transactionSummary.SIPTransactions}
                className="simple-card"
                // onClick={this.goToRoute(SIPS)}
              />
              {/* <DisplaySimpleCards
                image={"/images/transaction_fmps_dashbaord.svg"}
                name="FMPs Maturity"
                count={transactionSummary.FMPTransactions}
                className="simple-card"
                // onClick={this.goToRoute(FMPS_MATURITY)}
              /> */}
            </div>
          </div>
        </div>

        <div
          className="tab-container"
          style={{
            justifyContent: "flex-start",
            margin: "5px 10px 15px 10px",
          }}
        >
          <TabHeader
            value="AUM SUMMARY"
            active={this.state.Tab === "AUM_SUMMARY"}
            onClick={this.handleChangeTab("AUM_SUMMARY")}
          />
          <TabHeader
            value="FREQUENT  REPORTS"
            active={this.state.Tab === "FREQUENT_REPORTS"}
            onClick={this.handleChangeTab("FREQUENT_REPORTS")}
          />
          {/* <TabHeader
            value="SIP SUMMARY"
            active={this.state.Tab === "SIP_SUMMARY"}
            onClick={this.handleChangeTab("SIP_SUMMARY")}
          /> */}
        </div>

        {this.state.Tab === "FREQUENT_REPORTS" && (
          <div
            style={{ margin: "20px 0px 50px" }}
            className="transaction-details"
          >
            {/* <div className="dashboard-my-aum">FREQUENT MAIL BACK REPORTS</div> */}
            <Paper style={{ width: "100%" }} className="mailback-reports-div">
              {!!this.state.reports &&
                this.state.reports.map((item) => (
                  <SubReports
                    subtitle={
                      !!item && !!item.KDM_Repdesc
                        ? !!item.KDM_Repdesc.split("-")[2]
                          ? `${item.KDM_Repdesc.split("-")[1]}-${
                              item.KDM_Repdesc.split("-")[2]
                            }`
                          : item.KDM_Repdesc.split("-")[1]
                        : ""
                    }
                    key={item.KDM_Repcode}
                    value={item.KDM_Repcode}
                    onClick={this.handleChangeSubReports(item)}
                  />
                ))}
            </Paper>
          </div>
        )}

        {this.state.Tab === "SIP_SUMMARY" &&
          SipAumList &&
          SipAumList.length > 0 && (
            <div>
              <div className="dashboard-my-aum">SIP Summary</div>
              <div className="simple-card-container">
                <div className="simple-card-div">
                  <DisplaySimpleCards
                    image={"/images/sip_elm.svg"}
                    name="Expiring Next Month"
                    count={
                      !!sipSummaryData &&
                      !!sipSummaryData.Table2 &&
                      sipSummaryData.Table2[0]
                        ? sipSummaryData.Table2[0].SIP_expired_next_month
                        : 0
                    }
                    className="simple-card"
                    onClick={this.goToSIPRoute(EXPIRING_NEXT_MONTH)}
                  />

                  <DisplaySimpleCards
                    image={"/images/sip_closed.svg"}
                    name="Closed This Month"
                    count={
                      !!sipSummaryData &&
                      !!sipSummaryData.Table2 &&
                      sipSummaryData.Table2[0]
                        ? sipSummaryData.Table2[0].SIP_Closed_this_month
                        : 0
                    }
                    className="simple-card"
                    onClick={this.goToSIPRoute(CLOSED_THIS_MONTH)}
                  />
                  <DisplaySimpleCards
                    image={"/images/sip_im.svg"}
                    name="Investments"
                    count={
                      !!sipSummaryData &&
                      !!sipSummaryData.Table2 &&
                      sipSummaryData.Table2[0]
                        ? sipSummaryData.Table2[0].Sip_Investments
                        : 0
                    }
                    className="simple-card"
                    onClick={this.goToSIPRoute(SIP_INVESTMENTS)}
                  />
                </div>
              </div>
              {SipAumList.map((item, index) => (
                <AmcAum
                  value={item}
                  sipSummary={true}
                  key={index}
                  history={this.props.history}
                />
              ))}
            </div>
          )}

        {this.state.Tab === "AUM_SUMMARY" && (
          <div>
            {/* <div className="dashboard-my-aum">AUM of AMC`S</div> */}
            {!!AmcAumList && AmcAumList.length > 0 ? (
              AmcAumList.map((item, index) => (
                <AmcAum
                  value={item}
                  key={index}
                  history={this.props.history}
                  sipSummary={false}
                />
              ))
            ) : (
              <div
                style={{
                  color: "#005DAC",
                  fontSize: 15,
                  textAlign: "center",
                }}
              >
                No Data Found
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default connect(
  ({ authReducer, dashboard, investor, profileReducer }) => {
    const { token, userId, tran_enable_flag, posterStatus } = authReducer;
    const { count } = investor;
    const { profileData } = profileReducer;
    const {
      transactionSummary = {},
      my_aum,
      numberofschemes,
      aumData,
      fundData,
      totalAum,
      sipSummaryData,
      dashboardAUMData,
    } = dashboard;
    return {
      token,
      posterStatus,
      dashboardAUMData,
      userId,
      transactionSummary,
      sipSummaryData,
      my_aum,
      count,
      profileData,
      totalAum,
      numberofschemes,
      aumData,
      fundData,
      tran_enable_flag,
    };
  },
  {
    getDashboardData,
    getDashboardDataAum,
    PosterOpen,
    getSipSummary,
    getAumData,
    getInvestors,
    getInvestorDetails,
    getFrequentMailBackRequest,
    getProfileData,
    getMailbackList,
  }
)(Dashboard);

export class SubReports extends Component {
  render() {
    return (
      <div
        onClick={this.props.onClick}
        value={this.props.value}
        className="mailback-reports-sub-reports"
      >
        {this.props.subtitle}
        <Image src={"/images/next_icon.svg"} height={15} />
      </div>
    );
  }
}

export class MyAmcAum extends Component {
  goToRoute = (path, value) => () => {
    this.props.history.push({
      pathname: "/dashboard/investorType",
      state: {
        active: path,
        value: value,
        Type: !!this.props.sipSummary ? "SIP_SUMMARY" : "AUM_SUMMARY",
      },
    });
  };

  render() {
    const { value, dashboardAUMData, sipSummaryData, sipSummary } = this.props;

    const totalArray =
      !sipSummary &&
      !!dashboardAUMData &&
      dashboardAUMData.Table2 &&
      dashboardAUMData.Table2.reduce((prev, curr) => {
        const findItem = dashboardAUMData.Table4.find(
          (ele) => !!ele.Fund && String(ele.Fund).trim() === curr.fund_code
        );
        const data = !!findItem ? { ...curr, ...findItem } : { ...curr };
        prev = [...prev, data];
        return prev;
      }, []);

    let item = !!sipSummary
      ? !!sipSummaryData &&
        sipSummaryData.Table3.length > 0 &&
        sipSummaryData.Table3.find(
          (ele) => !!ele.Fund && ele.Fund.trim() === value.fund.trim()
        )
      : totalArray.find(
          (ele) => !!ele.Fund && String(ele.Fund).trim() === value.fund_code
        );

    return (
      <div style={{ margin: "20px 0px 10px" }} className="transaction-details">
        {/* <div
          style={{
            backgroundColor: "#f6f6f6",
            width: "100%",
            padding: "10px 20px",
          }}
        >
           <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Image
                src={`https://mfs.kfintech.com/mfs/mobileimages/189.png`}
                style={{ marginRight: 20, height: 30, width: 30 }}
              />
              <div style={{}} className="aum-desc">
                {value.descr}
              </div>
            </div>
            <div className="aum-text">
              Total Assets
              <span style={{ color: "#005DAC",marginLeft:10 }}>
                {!!value && value.aum ? `₹ ${value.aum}` : "0"}
              </span>
              <span
                style={{
                  color: "#7b8495",
                  fontSize: 10,
                  fontFamily: "Rubik",
                }}
              >
                {" "}
                (as on date {moment(new Date()).format("DD MMM `YY")})
              </span>
            </div>
          </div>

        </div> */}

        <div className="sub-title" style={{ marginBottom: -20 }}>
          Investors
        </div>
        <div className="simple-card-div">
          <DisplaySimpleCards
            image={"/images/new_investors.svg"}
            name="New Investors"
            count={!!item && !!item.New_Investors ? item.New_Investors : "0"}
            className="simple-card"
            onClick={this.goToRoute(NEW_INVESTORS, item)}
          />

          <DisplaySimpleCards
            image={"/images/active_investors.svg"}
            name="Active Investors"
            count={
              !!item && !!item.Active_Investors ? item.Active_Investors : "0"
            }
            className="simple-card"
            onClick={this.goToRoute(ACTIVE_INVESTORS, item)}
          />
          <DisplaySimpleCards
            image={"/images/inactive_investors.svg"}
            name="Inactive Investors"
            count={
              !!item && !!item.Inactive_Investors
                ? item.Inactive_Investors
                : "0"
            }
            className="simple-card"
            onClick={this.goToRoute(INACTIVE_INVESTORS, item)}
          />
        </div>
        <div className="sub-title" style={{ marginTop: 25, marginBottom: 15 }}>
          Brokerage Details
          <span
            style={{
              marginLeft: 10,
              fontSize: 17,
            }}
          >
            (last 6 months)
          </span>
        </div>
        <div className="brokeage-box-details">
          <SubAUMClass
            title={!!item && !!item.Previous6thMon ? item.Previous6thMon : "0"}
            date={
              !!item && !!item.Previous6thMonDt ? item.Previous6thMonDt : "NA"
            }
          />
          <SubAUMClass
            title={!!item && !!item.Previous5thMon ? item.Previous5thMon : "0"}
            date={
              !!item && !!item.Previous5thMonDt ? item.Previous5thMonDt : "NA"
            }
          />
          <SubAUMClass
            title={!!item && !!item.Previous4thMon ? item.Previous4thMon : "0"}
            date={
              !!item && !!item.Previous4thMonDt ? item.Previous4thMonDt : "NA"
            }
          />
          <SubAUMClass
            title={
              !!item && !!item.BeforelastMonth ? item.BeforelastMonth : "0"
            }
            date={
              !!item && !!item.BeforelastMonthDt ? item.BeforelastMonthDt : "NA"
            }
          />
          <SubAUMClass
            title={!!item && !!item.BeforeMonth ? item.BeforeMonth : "0"}
            date={!!item && !!item.BeforeMonthDt ? item.BeforeMonthDt : "NA"}
          />

          <SubAUMClass
            title={!!item && !!item.PresentMon ? item.PresentMon : "0"}
            date={!!item && !!item.PresentDt ? item.PresentDt : "NA"}
          />
        </div>
        <div
          style={{
            height: 1,
            width: "100%",
            background: "rgba(211,211,211,0.3)",
            marginTop: 20,
          }}
        ></div>
      </div>
    );
  }
}

export const AmcAum = connect(({ dashboard }) => {
  const { dashboardAUMData, sipSummaryData } = dashboard;

  return { dashboardAUMData, sipSummaryData };
})(MyAmcAum);

export class SubAUMClass extends Component {
  currencyConverter = (value) => {
    if (Math.abs(Number(value)) >= 1.0e5) {
      return `${parseFloat(Math.abs(Number(value)) / 1.0e5)} Lakhs`;
    } else if (Math.abs(Number(value)) >= 1.0e7) {
      return `${parseFloat(Math.abs(Number(value)) / 1.0e7)} Cr`;
    } else if (Math.abs(Number(value)) >= 1.0e3) {
      return `${parseFloat(Math.abs(Number(value)) / 1.0e3)} K`;
    } else {
      return Math.abs(Number(value));
    }
  };

  render() {
    const { title, date } = this.props;
    return (
      <Paper className="sub-aum-class">
        <div className="sub-aum-class-date">{date}</div>
        <div
          style={{ fontFamily: "Rubik-Bold", color: "#073d73" }}
          className="sub-aum-class-title"
        >
          {!!title ? <FormatCurrency value={title} /> : ""}
        </div>
      </Paper>
    );
  }
}

/* {!!fundPieData && fundPieData.length > 0 ? (
              <Paper className="pie-chart-paper fund">
                <PieDiagram
                  name="Fund"
                  data={!!fundPieData ? fundPieData : []}
                  innerRadius={30}
                  aumpieData={true}
                  height={190}
                  width={
                    !!windowWidth && parseFloat(windowWidth) < 540 ? 300 : 200
                  }
                  symbol="%"
                  cy={85}
                  cx={!!windowWidth && parseFloat(windowWidth) < 540 ? 150 : 85}
                  outerRadius={75}
                />
              </Paper>
            ) : !!fundPieData && fundPieData.length === 0 ? (
              <Paper className="pie-chart-paper fund" style={{ height: 150 }}>
                <div style={{display:"flex", height: 150,justifyContent:"center",alignItems:"center",textAlign:'center',fontFamily:"Rubik",color:"red"}}>No Fund wise found</div>
              </Paper>
            ) : (
              ""
            )} */
